import ExpenseLabels from './ExpenseLabels'

export default ExpenseLabels
